"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockShopifyVariant = void 0;
function mockShopifyVariant(overrides = {}) {
    return {
        id: '8094859084309583490',
        title: 'variant title',
        price: {
            amount: '7.49',
        },
        compareAtPrice: {
            amount: '0.0',
        },
        availableForSale: true,
        sku: 'MK-FK-PROD',
        image: {
            url: 'http://example.com/img',
        },
        quantityAvailable: 1,
        selectedOptions: [
            {
                name: 'Size',
                value: '2',
            },
        ],
        product: {
            handle: 'mock-product-handle',
            productType: 'softbaits-panfish-micro',
            vendor: 'Mockery Co',
            id: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0LzE3MTg3NjIwNDU0OTc=',
            title: 'product title',
            pricePro: null,
        },
        ...overrides,
    };
}
exports.mockShopifyVariant = mockShopifyVariant;
